<sd-link
  customClass="c__link"
  (clicked)="onDownloadDocument()"
  [link]="{url: data?.link, external: data?.external}"
>
  <ng-container *ngTemplateOutlet="documentLinkInformation" />
</sd-link>

<ng-template #documentLinkInformation>
  <sd-icon [brand]="brand" name="icon-document" [size]="iconSize.medium" />
  <sd-title [titleLevel]="titleLevel" customClass="brand--h5 is-bold" class="c__title">
    {{ data?.title }}
  </sd-title>
  @if (!data?.isLink) {
    <sd-icon name="icon-download" [brand]="brand" [size]="iconSize.small" />
  }
</ng-template>
